import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { loadConfig } from './actions/config';
import Layout from './components/layout/Layout';
import Home from './components/home/Home';
import Directory from './components/directory/Directory';
import BusinessDetail from './components/business/BusinessDetail';
import SubmitListing from './components/submit/SubmitListing';
import NotFound from './components/common/NotFound';
import Loader from './components/common/Loader';

/*
 * /api/config is fetched once, before any route renders, because `features`
 * decides which routes exist at all. Registering every route and hiding the
 * disabled ones would leave a working URL for a module that is switched off.
 */
export default function App() {
  const dispatch = useDispatch();
  const { loaded, features } = useSelector((state) => state.config);
  const failed = useSelector((state) => state.api.error);

  useEffect(() => {
    dispatch(loadConfig());
  }, [dispatch]);

  if (!loaded) {
    return failed ? (
      <div className="boot-error">
        <h1>LBI Local</h1>
        <p>The site could not reach its API. Refresh in a moment.</p>
      </div>
    ) : (
      <Loader full label="Loading the island" />
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />

        {features.directory && (
          <>
            <Route path="/directory" element={<Directory />} />
            <Route path="/directory/:categorySlug" element={<Directory />} />
            <Route path="/listing/:slug" element={<BusinessDetail />} />
            <Route path="/submit" element={<SubmitListing />} />
          </>
        )}

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}
